module.exports = __webpack_public_path__ + "static/media/foto2.200ee451.png";